export default "__VITE_ASSET__BZWgVSqD__"